import { render, staticRenderFns } from "./twiceGroupMove.vue?vue&type=template&id=c5ed3b50&scoped=true&"
import script from "./twiceGroupMove.vue?vue&type=script&lang=js&"
export * from "./twiceGroupMove.vue?vue&type=script&lang=js&"
import style0 from "./twiceGroupMove.vue?vue&type=style&index=0&id=c5ed3b50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5ed3b50",
  null
  
)

export default component.exports